import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import icoGoBack from '../../../assets/images/ico_goback.png';
import TabsMenu from '../../../components/button/tab-menu';
import TrainerTabs from '../atoms/trainer_tabs';

const TrainerDetail = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: trainerId } = useParams();
  const { setGModal, loading, setLoading } = props;
  const [trainerName, setTrainerName] = useState(null);
  const [component, setComponent] = useState(
    TrainerTabs({
      ...props,
      setTrainerName: setTrainerName,
      trainerId: trainerId,
    })[0].component
  );

  // 초기화
  // CenterTabs({ ...props })[0].component // center
  // CenterTabs({ ...props })[1].component // triner
  // CenterTabs({ ...props })[2].component // sequence
  // CenterTabs({ ...props })[3].component // lecture
  //----------------------------------------------------------------------------------------------------

  return (
    <div style={{ ...styles.constainer }}>
      <div style={{ ...styles.header }}>
        <Button
          style={{
            display: 'flex',
            width: '2.4rem',
            height: '2.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          icon={<img width={24} height={24} src={icoGoBack} />}
          onClick={(e) => {
            // goback
            // navigate(-1);
            navigate('/trainers', {
              replace: false,
              state: {
                ...location.state,
                isBack: true,
              },
            });
          }}
        />
        <div style={{ marginLeft: '2rem' }}>{`${
          trainerName || '-'
        } 상세보기`}</div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------- */}
      <div style={{ ...styles.tabs }}>
        <TabsMenu
          {...props}
          items={TrainerTabs({
            ...props,
            setTrainerName: setTrainerName,
            trainerId: trainerId,
          })}
          checkedIdx={1}
          setComponent={setComponent}
        />
      </div>
      {/* ---------------------------------------------------------------------------------------------------- */}
      {component}
      {/* ---------------------------------------------------------------------------------------------------- */}
    </div>
  );
};

const styles = {
  constainer: {
    display: 'flex',
    width: '100%',
    // flex: 1,
    // height: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  header: {
    display: 'flex',
    width: '100%',
    height: '4.6rem',
    alignItems: 'center',
    padding: '0rem 1rem 0rem 1rem',
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
    borderRadius: '0.6rem',

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
    color: '#4B465C',
  },
  tabs: {
    display: 'flex',
    width: '100%',
    height: '9rem',
    alignItems: 'center',
  },
};
export default TrainerDetail;
